// @flow

import React from 'react';
import { connect } from 'react-redux';
import Group from '../group';
import GroupTitle from '../groupTitle';
import {
  getModelLabel,
  getDeliveryTimeLabel,
  getDeliveryTimeDurationSingle,
  getDeliveryTimeDurationPlural,
} from '../../../../store/configuratorSettings/selectors';
// import type { State } from '../../../../types';
import ActiveItem from '../productGroups/atoms/activeItem';

type OwnProps = {|
  price: number,
  className?: string,
  delivery?: number,
|};

type StateProps = {|
  modelLabel: string,
  deliveryTimeLabel: string,
  durationLabelSingle: string,
  durationLabelPlural: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const Model = ({
  modelLabel,
  price,
  className,
  delivery,
  deliveryTimeLabel,
  durationLabelSingle,
  durationLabelPlural,
}: Props) => {
  const durationLabel = delivery && delivery === 1 ? durationLabelSingle : durationLabelPlural;
  return (
    <Group className={className}>
      <GroupTitle
        collapsible={false}
        title={modelLabel}
        price={price}
      />
      {delivery && <ActiveItem
        type=""
        title={`${deliveryTimeLabel}: ${delivery} ${durationLabel}`}
        show
      />}
    </Group>
  );
};

Model.defaultProps = {
  className: '',
  delivery: -1,
};

const mapStateToProps = (state): StateProps => ({
  modelLabel: getModelLabel(state),
  deliveryTimeLabel: getDeliveryTimeLabel(state),
  durationLabelSingle: getDeliveryTimeDurationSingle(state),
  durationLabelPlural: getDeliveryTimeDurationPlural(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(Model);
